import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'

import { api } from './api'
import * as actions from './actions'

const patchGoogleAnalytics = action$ => {
  return action$
    .ofType(actions.patchGoogleAnalytics.toString())
    .switchMap(action => {
      return api.patchGoogleAnalytics(action.payload)
        .map(actions.patchGoogleAnalyticsSuccess)
        .startWith(actions.patchGoogleAnalyticsPending())
        .catch(err => Observable.of(actions.patchGoogleAnalyticsFailed(err)))
    })
}

const getGoogleAnalyticsSettings = action$ => {
  return action$
    .ofType(actions.getGoogleAnalyticsSettings.toString())
    .switchMap(() => {
      return api.getGoogleAnalyticsSettings()
        .map(actions.getGoogleAnalyticsSettingsSuccess)
        .startWith(actions.getGoogleAnalyticsSettingsPending())
        .catch(err => Observable.of(actions.getGoogleAnalyticsSettingsFailed(err)))
    })
}

export const epic = combineEpics(patchGoogleAnalytics, getGoogleAnalyticsSettings)


// WEBPACK FOOTER //
// ./src/scripts/app/modules/googleAnalytics/epic.js